export var config = {
    players: 8,
    game_time_multiplier: 5,
};